export const translation = {
  //Initial Assessment - Result Translations
  "Application of Number": "Cymhwyso Rhif",
  "Using Data": "Defnyddio Data",
  "Whole Numbers": "Rhifau Cyfan",
  "Fractions, Decimals and Percentages": "Ffracsiynau, Degolion a Chanrannau",
  "Measures, Money and Time": "Mesurau, Arian ac Amser",
  "Shape, Space and Position": "Siâp, Gofod a Lleoliad",
  "Proportion, Ratio and Scale": "Cyfrannedd, Cymhareb a Graddfa",
  "Formulas and Equations": "Fformiwlâu a Hafaliadau",
  "Statistics and Probability": "Ystadegau a Thebygolrwydd",
  "Communication (English)": "Cyfathrebu (Saesneg)",
  "Communication (Welsh)": "Cyfathrebu (Cymraeg)",
  "Speaking and Listening": "Siarad a Gwrando",
  Reading: "Darllen",
  "Read and understand words": "Darllen a deall geiriau",
  "Read and understand text": "Darllen a deall testun",
  "Read text to find information": "Darllen testun i ddod o hyd i wybodaeth",
  Writing: "Ysgrifennu",
  "Write relevant and appropriate text":
    "Ysgrifennu testun perthnasol a phriodol",
  "Spell correctly": "Sillafu’n gywir",
  "Punctuate correctly": "Atalnodi’n gywir",
  "Use correct grammar": "Defnyddio gramadeg yn gywir",
  "Digital Literacy": "Llythrennedd Digidol",
  "Digital Literacy Self-Assessment": "Llythrennedd Digidol Hunan-Asesiad",
  "Digital Responsibility": "Cyfrifoldeb Digidol",
  "Digital Productivity": "Cynhyrchiant Digidol",
  "Digital Information Literacy": "Llythrennedd Gwybodaeth Ddigidol",
  "Digital Collaboration": "Cydweithio Digidol",
  "Digital Creativity": "Creadigrwydd Digidol",
  "Digital Learning": "Dysgu Digidol",
  //Initial Assessment - Q and A translations
  "Turn on and turn off a digital device": "Cychwyn a diffodd dyfais ddigidol",
  "State ways of keeping safe online": "Nodi ffyrdd o fod yn ddiogel ar-lein",
  "Demonstrate an ability to make changes using an input device":
    "Dangos gallu i wneud newidiadau gan ddefnyddio dyfais mewnbynnu",
  "Open a file": "Agor ffeil",
  "Identify a digital source of information":
    "Enwi ffynhonnell wybodaeth ddigidol",
  "Use digital tools to collaborate with others to complete a task":
    "Defnyddio offer digidol i gydweithio ag eraill i gyflawni tasg",
  "Use creative features to enhance a digital resource":
    "Defnyddio nodweddion creadigol i wella adnodd digidol",
  "List digital devices and tools that can be used for learning":
    "Rhestru dyfeisiau ac offer digidol y gellir eu defnyddio ar gyfer dysgu",
  "Present at least one piece of information for the task in a digital format":
    "Cyflwyno o leiaf un darn o wybodaeth ar gyfer y dasg mewn fformat digidol",
  "Use basic formatting techniques to present digital information":
    "Defnyddio technegau fformatio syml i gyflwyno gwybodaeth ddigidol",
  "State ways of keeping yourself safe in a range of contexts (including messages, social media and websites)":
    "Nodi ffyrdd o gadw'ch hun yn ddiogel mewn ystod o gyd-destunau (gan gynnwys negeseuon, cyfryngau cymdeithasol a gwefannau)",
  "Create and save a file": "Creu a chadw ffeil",
  "Open a personal file, email or message and respond to the personal file, email or message":
    "Agor ffeil, neges e-bost neu neges bersonol ac ymateb i'r ffeil, neges e-bost neu neges bersonol",
  "Identify basic digital hardware": "Enwi caledwedd digidol syml",
  "Locate information from a given digital source":
    "Dod o hyd i wybodaeth o ffynhonnell ddigidol benodol",
  "Communicate digitally with a team to plan a task":
    "Cyfathrebu'n ddigidol â thîm i gynllunio tasg",
  "Use creative tools to create and/or edit a digital resource":
    "Defnyddio offer creadigol i greu a/neu olygu adnodd digidol",
  "Give examples of skills and knowledge that can be learned using digital tools":
    "Rhoi enghreifftiau o sgiliau a gwybodaeth y gellir eu dysgu drwy ddefnyddio offer digidol",
  "Configure security settings to keep yourself safe in a digital world (eg passwords, fingerprints, passcodes etc)":
    "Ffurfweddu gosodiadau diogelwch i gadw'ch hun yn ddiogel mewn byd digidol (e.e. cyfrineiriau, olion bysedd, codau mynediad ayb)",
  "Choose appropriate creative tools": "Dewis offer creadigol priodol",
  "Interact safely and appropriately in a digital world in a range of contexts (including using social media, messages, websites and online-transactions)":
    "Rhyngweithio'n ddiogel ac yn briodol mewn byd digidol mewn ystod o gyd-destunau (gan gynnwys defnyddio cyfryngau cymdeithasol, negeseuon, gwefannau a thrafodion ar-lein)",
  "Create basic folder structures to store information":
    "Creu strwythurau ffolderi syml i storio gwybodaeth",
  "Identify digital tools, technologies and techniques to present digital information":
    "Enwi offer, technolegau a thechnegau digidol i gyflwyno gwybodaeth ddigidol",
  "Access digital data": "Cael mynediad at ddata digidol",
  "Search for appropriate digital information":
    "Chwilio am wybodaeth ddigidol briodol",
  "Identify reliable resources and give reasons why they are reliable":
    "Adnabod adnoddau dibynadwy a rhoi rhesymau pam eu bod yn ddibynadwy",
  "Identify and use appropriate synchronous (real time) and asynchronous methods to collaborate and communicate online to complete a task":
    "Enwi a defnyddio dulliau priodol cydamseredig (amser real) ac anghydamseredig i gydweithio a chyfathrebu ar-lein er mwyn cyflawni tasg",
  "Choose appropriate digital tools for a specific purpose":
    "Dewis offer digidol priodol at bwrpas penodol",
  "Identify appropriate digital tools to support specific learning activities":
    "Enwi offer digidol priodol i ategu gweithgareddau dysgu penodol",
  "State what is meant by a digital footprint":
    "Nodi beth yw ystyr ôl troed digidol",
  "Use appropriate formatting techniques to present digital information":
    "Defnyddio technegau fformatio priodol i gyflwyno gwybodaeth ddigidol",
  "Use appropriate language and behaviour":
    "Defnyddio iaith ac ymddygiad priodol",
  "Outline how online information can impact on self and others":
    "Disgrifio sut y mae gwybodaeth ar-lein yn gallu effeithio'n bersonol ac effeithio ar eraill",
  "Store and access digital data": "Storio a chael mynediad at ddata digidol",
  "Identify a common digital problem and solution":
    "Adnabod problem ddigidol gyffredin a dod o hyd i ateb",
  "Select and use at least one appropriate digital technology and one appropriate digital tool to complete a task or solve a problem":
    "Dewis a defnyddio o leiaf un dechnoleg ddigidol briodol ac un offeryn digidol priodol i gyflawni tasg neu ddatrys problem",
  "Use suitable keywords or phrases to search for information to complete a task or solve a simple problem":
    "Defnyddio allweddeiriau neu ymadroddion addas i chwilio am wybodaeth i gyflawni tasg neu ddatrys problem syml",
  "Retrieve and use digital information which is in a suitable format for a target audience":
    "Adfer a defnyddio gwybodaeth ddigidol sydd mewn fformat addas ar gyfer cynulleidfa benodol",
  "Outline how digital collaborative tools could be used to enhance personal and professional practices":
    "Disgrifio sut y gellid defnyddio offer cydweithio digidol i wella arferion personol a phroffesiynol",
  "Use an appropriate creative digital approach to complete a task":
    "Defnyddio ffordd ddigidol greadigol briodol i gyflawni tasg",
  "Identify a range of appropriate digital technologies/tools which extend learning opportunities":
    "Enwi offer digidol sy'n ategu cyfleoedd dysgu",
  "Use appropriate tools and techniques to work safely in the digital world":
    "Defnyddio iaith ac ymddygiad priodol",
  "Outline how to report inappropriate interactions and/or content":
    "Disgrifio sut y mae rhoi gwybod am ryngweithio a/neu gynnwys amhriodol",
  "Identify methods of securing digital information":
    "Enwi dulliau o ddiogelu gwybodaeth ddigidol",
  "Demonstrate effective and efficient synchronous (real time) and asynchronous methods of collaborating with an online team to complete a task or solve a problem":
    "Dangos dulliau cydamseredig (amser real) ac anghydamseredig effeithiol ac effeithlon i gydweithio â thîm ar-lein i gyflawni tasg neu ddatrys problem",
  "Describe the reasons for using the approach and its creative impact":
    "Disgrifio’r rhesymau dros ddefnyddio’r dull a’i effaith greadigol",
  "Describe the risks when interacting in a digital environment":
    "Disgrifio’r risgiau wrth ryngweithio mewn amgylchedd digidol",
  "Describe potential consequences of inappropriate or unlawful online activity":
    "Disgrifio canlyniadau posibl gweithgaredd ar-lein sy'n amhriodol neu'n anghyfreithlon",
  "Identify and evaluate appropriate methods of securing digital information":
    "Enwi a gwerthuso dulliau priodol o ddiogelu gwybodaeth ddigidol",
  "Describe the basic configuration of common digital devices":
    "Disgrifio ffurfweddiad syml dyfeisiau digidol cyffredin",
  "Assess and select the most appropriate digital technologies and tools to complete a task or solve a problem":
    "Asesu a dewis yr offer a'r technolegau digidol mwyaf priodol i gyflawni tasg neu ddatrys problem",
  "Organise and classify digital information into a structured format to complete a task or solve a problem":
    "Trefnu a chategoreiddio gwybodaeth ddigidol mewn fformat strwythuredig er mwyn cyflawni tasg neu ddatrys problem",
  "Assess the digital information for currency, relevance, authority, accuracy and purpose":
    "Asesu'r wybodaeth ddigidol i weld a yw'n gyfredol, yn berthnasol, yn gywir, ac asesu diben ac awdurdod",
  "Select a combination of digital methods of communicating with a team to complete a task or solve a problem":
    "Dewis cyfuniad o ddulliau digidol i gyfathrebu â thîm er mwyn cyflawni tasg neu ddatrys problem",
  "Give the advantages and disadvantages of chosen creative tools and techniques":
    "Rhoi manteision ac anfanteision yr offer a'r technegau creadigol sydd wedi'u dewis",
  "Describe how digital technologies/tools improved the learning experience":
    "Disgrifio sut y gwnaeth technolegau/offer digidol wella'r profiad dysgu",
  "Describe ways of staying safe in a wide range of digital communities and environments":
    "Disgrifio ffyrdd o fod yn ddiogel mewn ystod eang o gymunedau ac amgylcheddau digidol",
  "Conduct a review of personal digital footprint":
    "Adolygu ôl troed digidol personol",
  "Assess and resolve common digital problems":
    "Asesu a datrys problemau digidol cyffredin",
  "Compare a range of digital tools which extend personal learning with reference to how these meet personal learning requirements and preferences":
    "Cymharu ystod o offer digidol sy'n ehangu dysgu personol gan gyfeirio at sut y mae'r rhain yn bodloni dewisiadau a gofynion dysgu personol",
  "Select and justify protocols for digital responsibility and digital security in a wide range of digital communities and environments":
    "Dewis a chyfiawnhau protocolau ar gyfer cyfrifoldeb digidol a diogelwch digidol mewn ystod eang o gymunedau ac amgylcheddau digidol",
  "Ensure safety protocols are in place for the audience":
    "Sicrhau bod protocolau diogelwch ar waith ar gyfer y gynulleidfa",
  "Manage and review the most efficient way of organising the storage and permissioning of digital resources":
    "Rheoli ac adolygu’r ffordd fwyaf effeithlon o drefnu ar gyfer storio ac awdurdodi adnoddau digidol",
  "Critically evaluate a combination of digital technologies and tools and their appropriateness for completing given complex tasks or complex problems":
    "Mynd ati'n feirniadol i werthuso cyfuniad o offer a thechnolegau digidol ynghyd â pha mor briodol ydynt ar gyfer cyflawni tasgau cymhleth penodol neu ddatrys problemau cymhleth",
  "Critically evaluate the capacity of the selected technologies and tools to present solutions professionally":
    "Mynd ati'n feirniadol i werthuso i ba raddau y mae'r offer a'r technolegau a ddewiswyd yn gallu cyflwyno atebion yn broffesiynol",
  "Critically analyse digital sources of information with reference to how search engine results are manipulated by a variety of processes":
    "Mynd ati'n feirniadol i ddadansoddi ffynonellau digidol o wybodaeth gan gyfeirio at sut y mae defnyddio amrywiol brosesau i drin canlyniadau peiriannau chwilio",
  "Use digital information which is in a suitable format for a range of audiences to complete complex tasks or solve complex problems":
    "Defnyddio gwybodaeth ddigidol sydd mewn fformat addas ar gyfer amrywiaeth o gynulleidfaoedd i gyflawni tasgau cymhleth neu ddatrys problemau cymhleth",
  "Explore opportunities to collaborate with others to complete a complex task or solve a complex problem":
    "Chwilio am gyfleoedd i gydweithio ag eraill i gyflawni tasg gymhleth neu ddatrys problem gymhleth",
  "Respond appropriately to constructive feedback":
    "Ymateb yn briodol i adborth adeiladol",
  "Critically assess and analyse digital technologies, tools and techniques which extend learning with reference to how these meet personal learning requirements and preferences":
    "Mynd ati'n feirniadol i asesu a dadansoddi'r technolegau, offer a thechnegau digidol sy'n ehangu dysgu gan gyfeirio at sut y mae'r rhain yn bodloni dewisiadau a gofynion dysgu personol",
  "Explain how to minimise risks for personal and professional digital projects using a range of protocols":
    "Egluro sut y mae lleihau risgiau ar gyfer prosiectau digidol personol a phroffesiynol gan ddefnyddio amrywiaeth o brotocolau",
  "Effectively manage storage structures of digital resources":
    "Rheoli strwythurau storio'r adnoddau digidol yn effeithiol",
  "Carry out advanced searches using appropriate search engines, functions and features":
    "Adfer, trefnu a chategoreiddio gwybodaeth ddigidol mewn fformat strwythuredig gan ddefnyddio strategaethau mynegeio priodol",
  "Critically analyse and assess safe and secure ways to collaborate with an online team":
    "Mynd ati'n feirniadol i ddadansoddi ac asesu ffyrdd diogel o gydweithio â thîm ar-lein",
  "Critically analyse and assess how solutions are developed using digital creativity and their impact":
    "Critically analyse and assess how solutions are developed using digital creativity and their impact",
  "add single-digit numbers with totals to 10 and subtract single-digit numbers from whole numbers up to 10":
    "adio rhifau un digid hyd at gyfanswm o 10, a thynnu rhifau un digid o rifau cyfan, hyd at 10",
  "count reliably up to 10 items": "rhifo’n ddiogel hyd at 10 eitem",
  "understand everyday positional vocabulary":
    "deall geirfa leoliadol bob dydd",
  "describe size and use direct comparisons for the size of at least two items":
    "disgrifio maint a chymharu maint o leiaf dau beth yn uniongyrchol",
  "sort and classify objects using a single criterion":
    "trefnu a dosbarthu gwrthrychau gan ddefnyddio un maen prawf",
  "describe weight, and use direct comparisons for weight of items":
    "disgrifio pwysau, a chymharu pwysau eitemau’n uniongyrchol",
  "recognise and select coins and notes":
    "adnabod a dewis darnau a phapurau arian",
  "read and understand information given by numbers and symbols in simple graphical, numerical and written material":
    "darllen a deall gwybodaeth a roddir gan rifau a symbolau, mewn deunyddiau graffigol, rhifiadol ac ysgrifenedig syml",
  "recognise and name common 2-D and 3-D shapes including rectangle, square, circle and cube":
    "adnabod ac enwi siapau 2-D a 3-D cyffredin yn cynnwys petryal, sgwâr, cylch a chiwb",
  "interpret + and [minus] and = in practical situations for solving problems":
    "dehongli +, – a = mewn sefyllfaoedd ymarferol i ddatrys problemau",
  "describe capacity and use direct comparisons for capacity of items":
    "disgrifio cynhwysedd a chymharu cynhwysedd eitemau’n uniongyrchol",
  "read, write, order and compare whole numbers up to 10 including zero":
    "darllen, ysgrifennu, trefnu a chymharu rhifau cyfan hyd at 10, yn cynnwys sero",
  "read, understand and extract information given by numbers, symbols, lists, simple tables, simple diagrams, charts and block graphs in numerical and written material":
    "darllen, deall a chael hyd i’r wybodaeth a roddir gan rifau, symbolau, rhestrau, tablau syml, diagramau syml, siartiau a graffiau bloc, mewn deunyddiau rhifiadol ac ysgrifenedig",
  "find halves and quarters of small numbers of items or shapes":
    "darganfod haneri a chwarteri nifer fach o eitemau neu siapau",
  "add and subtract two-digit whole numbers":
    "adio a thynnu rhifau cyfan dau ddigid",
  "estimate, measure and compare length, weight and capacity using common standard and non-standard units":
    "amcangyfrif, mesur a chymharu hyd, pwysau a chynhwysedd gan ddefnyddio unedau safonol ac unedau ansafonol cyffredin",
  "read and compare positive temperatures in everyday situations":
    "darllen a chymharu tymheredd positif mewn sefyllfaoedd bob dydd",
  "describe the properties of common 2-D and 3-D shapes":
    "disgrifio nodweddion siapau 2-D a 3-D cyffredin",
  "make amounts of money up to £1 in different ways using 1p, 2p, 5p, 10p, 20p and 50p coins":
    "defnyddio darnau arian 1c, 2c, 5c, 10c, 20c a 50c mewn gwahanol ffyrdd i greu swm o £1",
  "read, write, order and compare whole numbers up to 100":
    "darllen, ysgrifennu, trefnu a chymharu rhifau cyfan hyd at 100",
  "read and record time in common date formats, and understand time displayed on analogue and 12-hour digital clocks in hours, half-hours and quarter-hours":
    "darllen a chofnodi amser yn y fformatau cyffredin ar gyfer dyddiad a deall amser wedi ei ddangos mewn awr, hanner awr a chwarter awr ar glociau analog a chlociau digidol 12 awr",
  "calculate the cost in pounds of more than one item and the change from a transaction":
    "cyfrifo cost mwy nag un eitem mewn punnoedd a’r newid wrth brynu",
  "recognise and name 2-D and 3-D shapes including triangles, cylinders and pyramids":
    "adnabod ac enwi siapau 2-D a 3-D yn cynnwys trionglau, silindrau a phyramidiau",
  "use positional vocabulary": "defnyddio geirfa leoliadol",
  "add and subtract using three-digit numbers":
    "adio a thynnu gan ddefnyddio rhifau tri digid",
  "divide two-digit whole numbers by single-digit whole numbers and interpret remainders":
    "rhannu rhifau cyfan dau ddigid â rhifau cyfan un digid a dehongli’r gweddil",
  "read, write and understand decimals up to two decimal places in practical contexts":
    "darllen, ysgrifennu a deall degolion hyd at ddau le degol mewn cyd-destunau ymarferol",
  "read, write and understand common fractions":
    "darllen, ysgrifennu a deall ffracsiynau cyffredin",
  "sort 2-D and 3-D shapes to solve practical problems using properties":
    "dosbarthu siapau 2-D a 3-D i ddatrys problemau ymarferol gan ddefnyddio nodweddion",
  "estimate, read, measure and compare length, capacity, weight and temperature using non-standard and standard units":
    "amcangyfrif, darllen, mesur a chymharu hyd, cynhwysedd, pwysau a thymheredd gan ddefnyddio unedau safonol ac unedau ansafonol cyffredin",
  "estimate, calculate and compare money by adding and subtracting sums using decimal notation":
    "amcangyfrif, cyfrifo a chymharu arian drwy: adio a thynnu symiau gan ddefnyddio degolion; talgrynnu symiau i'r £1, 10c agosaf; amcangyfrif cyfrifiadau",
  "make numerical comparisons from bar charts and pictograms":
    "gwneud cymariaethau rhifiadol gan ddefnyddio siartiau bar a phictogramau",
  "read, understand and extract information given by numbers, symbols, lists, tables, simple diagrams, charts and block graphs used for different purposes and in different ways in numerical and written material":
    "darllen, deall a chael hyd i’r wybodaeth a roddir gan rifau, symbolau, rhestrau, tablau, diagramau syml, siartiau a graffiau bloc sy’n cael eu defnyddio i bwrpasau gwahanol ac mewn ffyrdd gwahanol, mewn deunyddiau rhifiadol ac ysgrifenedig",
  "approximate by rounding numbers less than 1000 to the nearest 10 or 100":
    "rhoi brasamcan drwy dalgrynnu rhifau llai na 1000 i’r 10 neu’r 100 agosaf",
  "multiply two-digit whole numbers by single-digit whole numbers":
    "lluosi rhifau cyfan dau ddigid â rhifau cyfan un digid",
  "recognise and use equivalent forms": "adnabod a defnyddio ffurfiau cyfwerth",
  "read, measure and record time using: am and pm, common date formats, digital clocks and analogue clocks to the nearest five-minute intervals":
    "darllen, mesur a chofnodi amser gan ddefnyddio: a.m. a p.m.; fformatau dyddiad cyffredin; clociau digidol a chlociau analog i’r cyfnodau pum munud agosaf",
  "j) use probability to show (using fractions, decimals and percentages) that some events are more likely to occur than others":
    "j) defnyddio tebygolrwydd i ddangos (drwy ddefnyddio ffracsiynau, degolion a chanrannau) fod rhai digwyddiadau’n fwy tebygol nag eraill",
  "h) work out perimeters, areas and volumes":
    "h) cyfrifo perimedrau, arwynebeddau a chyfeintiau",
  "b) add and subtract with whole numbers and simple decimals, with and without a calculator":
    "b) adio a thynnu â rhifau cyfan a degolion syml, gyda chyfrifiannell a hebddo",
  "a) read, understand and extract information from tables, charts, simple graphs and diagrams":
    "a) darllen, deall a chodi gwybodaeth o dablau, siartiau, graffiau syml a diagramau",
  "d) use simple fractions and percentages":
    "d) defnyddio ffracsiynau syml a chanrannau",
  "e) read, measure and record time in common date and time formats and in context":
    "e) darllen, mesur a chofnodi amser mewn fformatau cyffredin ar gyfer dyddiad ac amser ac yn ei gyd-destun",
  "f) add, subtract, multiply, divide and record sums of money":
    "f) adio, tynnu, lluosi, rhannu a chofnodi symiau o arian",
  "c) multiply and divide a simple decimal by a whole number, with and without a calculator":
    "c) lluosi a rhannu degolyn syml â rhif cyfan, gyda chyfrifiannell a hebddo",
  "i) use ratios and proportions": "i) defnyddio cymarebau a chyfrannau",
  "a) identify more than one appropriate way to present findings to a given audience, including using tables, charts, graphs or diagrams":
    "a) enwi mwy nag un ffordd briodol o gyflwyno’ch canfyddiadau i gynulleidfa benodol, gan gynnwys defnyddio tablau, siartiau, graffiau neu diagramau",
  "k) find the range and average (mean) of up to 10 items":
    "k) canfod amrediad a chyfartaledd (cymedr) hyd at 10 o eitemau",
  "b) read and understand numbers presented in different ways, including large numbers in figures or words, simple fractions, decimals, percentages, ratios and negative numbers":
    "b) darllen a deall rhifau sydd wedi’u cyflwyno mewn gwahanol ffyrdd, gan gynnwys rhifau mawr mewn ffigurau neu eiriau, ffracsiynau syml, degolion, canrannau, cymarebau a rhifau negatif",
  "e) use equivalencies between common fractions, percentages and decimals":
    "e) defnyddio cywertheddoedd rhwng ffracsiynau cyffredin, canrannau a degolion",
  "g) calculate within a system by: - adding and subtracting common units of measure - converting units of measure in the system":
    "g) cyfrifo o fewn system drwy: - adio a thynnu unedau mesur cyffredin - trawsnewid unedau mesur yn y system",
  "c) label work correctly": "c) labelu gwaith yn gywir",
  "b) carry out calculations involving two or more steps, with numbers of any size, with and without a calculator":
    "b) gwneud cyfrifiadau o ddau gam neu ragor, â rhifau o unrhyw faint, gyda chyfrifiannell neu hebddo",
  "l) understand and use relevant formulae":
    "l) deall a defnyddio fformiwlâu perthnasol",
  "k) use range to describe the spread within sets of data":
    "k) defnyddio amrediad i ddisgrifio’r rhychwant o fewn setiau data",
  "i) understand compound measures": "i) deall mesurau cyfansawdd",
  "h) use proportions and calculate using ratios":
    "h) defnyddio cyfrannau a chyfrifo â chymarebau",
  "d) work with, and convert between fractions, decimals and percentages":
    "d) defnyddio ffracsiynau, degolion a chanrannau a thrawsnewid o un i'r llall",
  "a) read, understand and interpret information from tables, charts, graphs and diagrams":
    "a) darllen, deall a dehongli gwybodaeth o dablau, siartiau, graffiau a diagramau",
  "f) calculate within a system and between systems using: - conversion tables and scales - approximate conversion factors":
    "f) cyfrifo o fewn system a rhwng systemau gan ddefnyddio: - tablau a graddfeydd trawsnewid - ffactorau trawsnewid bras",
  "g) recognise and use common 2-D representations of 3-D objects":
    "g) adnabod a defnyddio cynrychioliadau 2-D cyffredin o wrthrychau 3-D",
  "b) identify and describe appropriate ways to present findings to different audiences, including numerical, graphical and written formats":
    "b) enwi a disgrifio ffyrdd priodol o gyflwyno canfyddiadau i wahanol gynulleidfaoedd, gan gynnwys fformatau rhifiadol, graffigol ac ysgrifenedig",
  "m) calculate efficiently using whole numbers, fractions, decimals and percentages":
    "m) cyfrifo’n effeithlon gan ddefnyddio rhifau cyfan, ffracsiynau, degolion a chanrannau",
  "j) compare sets of data of a suitable size, selecting and using the mean / median / mode as appropriate":
    "j) cymharu setiau data o faint addas, gan ddewis a defnyddio’r cymedr / canolrif / modd fel y bo’n briodol",
  "b) read and understand numbers presented in different ways":
    "b) darllen a deall rhifau sydd wedi’u cyflwyno mewn ffyrdd gwahanol",
  "e) calculate time in different formats":
    "e) cyfrifo amser mewn gwahanol fformatau",
  "g) solve problems involving 2-D shapes and parallel lines":
    "g) datrys problemau sy’n cynnwys siapiau 2-D a llinellau paralel",
  "g) calculate with sums of money in different currencies":
    "g) cyfrifo â symiau o arian mewn gwahanol fathau o arian cyfred",
  "l) work out actual dimensions from scale drawings and scale quantities up and down":
    "l) cyfrifo dimensiynau gwirioneddol ar sail lluniadau wrth raddfa a chynyddu a lleihau meintiau wrth raddfa",
  "j) calculate within and between systems and make accurate comparisons":
    "j) cyfrifo o fewn systemau a rhwng systemau a gwneud cymariaethau cywir",
  "i) read and understand ways of writing very large and very small numbers":
    "i) darllen a deall ffyrdd o ysgrifennu rhifau mawr iawn a rhifau bach iawn",
  "b) carry out multi-stage calculations efficiently with numbers of any size":
    "b) gwneud cyfrifiadau amlran yn effeithlon â rhifau o unrhyw faint",
  "o) rearrange and use formulae, equations and expressions":
    "o) aildrefnu a defnyddio fformiwlâu, hafaliadau a mynegiadau",
  "n) compare distributions, using measures of average and interquartile range, and estimate mean, median and range of grouped data":
    "n) cymharu dosbarthiadau, gan ddefnyddio mesuriadau o amrediadau cyfartalog a rhyngchwartel, ac amcangyfrif cymedr, canolrif ac amrediad grwpiau o ddata",
  "f) calculate missing angles and sides in right-angled triangles from known sides and angles":
    "f) cyfrifo onglau ac ochrau coll mewn trionglau ongl sgwâr ar sail ochrau ac onglau hysbys",
  "b) read, understand and interpret information from tables, charts, graphs and diagrams":
    "b) darllen, deall a dehongli gwybodaeth o dablau, siartiau, graffiau a diagramau",
  "g) group data into classes of width appropriate to the data":
    "g) grwpio data yn ddosbarthiadau sydd o led priodol i’r data",
  "h) calculate, measure, record and compare time in different formats":
    "h) cyfrifo, mesur, cofnodi a chymharu amser mewn fformatau gwahanol",
  "k) solve problems involving irregular 2-D shapes":
    "k) datrys problemau sy’n cynnwys siapiau 2-D afreolaidd",
  "e) use mental arithmetic involving numbers, simple fractions, and percentages":
    "e) defnyddio rhifyddeg pen gan gynnwys rhifau, ffracsiynau syml a chanrannau",
  "b) select and use appropriate methods to effectively present and illustrate findings, showing trends and making comparisons, including numerical, graphical and written formats":
    "b) dewis a defnyddio dulliau priodol i gyflwyno ac egluro'r canfyddiadau yn effeithiol gan ddangos tueddiadau a chymharu, gan gynnwys fformatau rhifiadol, graffigol ac ysgrifenedig",
  //Learning Plan > Subcategories - Titles
  "2D and 3D Shapes": "Siapiau 2-D a 3-D",
  "Alphabetical order": "Trefn yr wyddor",
  Apostrophes: "Collnodau",
  "Appropriate language": "Iaith briodol",
  "Calculating with numbers": "Cyfrifo gan ddefnyddio rhifau",
  "Calculating with shapes": "Cyfrifo gan ddefnyddio siapiau",
  "Capital letters": "Priflythyrennau",
  "Captions and illustrations": "Capsiynau a darluniau",
  Commas: "Atalnodau",
  "Critically analyse and review techniques":
    "Gwerthuso'n feirniadol ac adolygu technegau",
  "Critically evaluate tools, technologies and techniques":
    "Gwerthuso'n feirniadol offer, technolegau a thechnegau",
  Decimals: "Degolion",
  "End of sentence punctuation": "Atalnodi diwedd brawddeg",
  Equations: "Hafaliadau",
  "Find information": "Dod o hyd i wybodaeth",
  Formulas: "Fformiwlâu",
  Fractions: "Ffracsiynau",
  Homophones: "Homoffonau",
  "Inference and bias": "Casglu ac adnabod rhagfarn",
  "Instructions and directions": "Cyfarwyddiadau",
  "Inverted commas": "Dyfynodau",
  "Manage information storage": "Rheoli storio gwybodaeth",
  "Manage personal information": "Rheoli gwybodaeth bersonol",
  Money: "Arian",
  Numbers: "Rhifau",
  "Obtain information": "Casglu gwybodaeth",
  "Obtain, organise and classify information":
    "Casglu, trefnu a chategoreiddio gwybodaeth",
  "Organise and classify information": "Trefnu a chategoreiddio gwybodaeth",
  "Organise/structure writing": "Trefnu/strwythuro gwaith ysgrifenedig",
  Percentages: "Canrannau",
  "Plan and draft": "Gynllunio a drafftio",
  Position: "Lleoliad",
  "Prefixes and suffixes": "Rhagddodiaid ac ôl-ddodiaid",
  "Present data": "Cyflwyno data",
  "Present information": "Cyflwyno gwybodaeth",
  Probability: "Tebygolrwydd",
  Proofread: "Prawfddarllen",
  "Purpose and audience": "Pwrpas a chynulleidfa",
  "Ratio and proportion": "Cymhareb a chyfrannedd",
  "Relevant information": "Gwybodaeth berthnasol",
  "Resolve problems": "Datrys problemau",
  Scale: "Graddfa",
  "Semi colons": "Semicolonau",
  "Semi-colons": "Semi-colonau",
  Sorting: "Trefnu",
  "Spelling and spelling rules": "Sillafu a rheolau sillafu",
  Statistics: "Ystadegau",
  "Subject-verb agreement": "Cytundeb goddrych-berf",
  "Suitable formats": "Fformatiau addas",
  Summarise: "Crynhoi",
  Time: "Amser",
  "Understand data": "Deall data rhifiadol",
  "Understand/extract information": "Deall/dethol gwybodaeth",
  "Use applications and devices": "Defnyddio rhaglenni a dyfeisiau",
  "Using measures": "Defnyddio mesuriadau",
  "Word types": "Mathau o eiriau",
  "Words, signs and symbols": "Geiriau, arwyddion a symbolau",
  "Work safely": "Gweithio'n ddiogel",
  "Write sentences": "Ysgrifennu brawddegau",
  Add: "Adio",
  Remove: "Dileu",
  "Disable for tutors": "Analluoga tiwtoriaid",
  "Disable for organisation administrators": "Analluogi gweinyddwyr sefydliad",
  "Add groups": "Ychwanegu grwpiau",
  "Delete groups": "Dileu grwpiau",
  "Add learners": "Ychwanegu dysgwyr",
  "Delete learners via learners list": "Dileu dysgwyr drwy restr dysgwyr",
  "Disable and enable learners via learners list":
    "Analluogi a galluogi dysgwyr drwy restr dysgwyr",
  "Enter external IA results": "Rhowch ganlyniadau IA allanol",
  "Assign/unassign courses": "Cyrsiau aseinio/aseinio",
  "Batch delete/disable by import": "Swp dileu / analluogi gan fewnforio",
  "Not Started": "Heb ddechrau",
  "In Progress": "Ar y gweill",
  "Not Assigned": "Ddim wedi'i neilltuo",
  "Assessment (not started)": "Asesiad (heb ei gychwyn)",
  "Assessment (incomplete)": "Asesiad (anghyflawn)",
  Assessment: "Asesiad",
  "Assign Targets": "Aseinio targedau",
  Learning: "Dysg",
  "Assessment Completed": "Asesiad wedi'i gwblhau",
  Unassigned: "Dad-ddynodi",
  Assigned: "Ddynodi",
  "Application of Number was enabled successfully.":
    "Caniatawyd cymhwyso Rhif yn llwyddiannus.",
  "Application of Number was disabled successfully.":
    "Analluogwyd cymhwyso Rhif yn llwyddiannus.",
  "Communication (English) was enabled successfully.":
    "Caniatawyd Cyfathrebu (Saesneg) yn llwyddiannus.",
  "Communication (English) was disabled successfully.":
    "Roedd cyfathrebu (Saesneg) yn anabl yn llwyddiannus.",
  "Communication (Welsh) was enabled successfully.":
    "Caniatawyd cyfathrebu (Cymraeg) yn llwyddiannus.",
  "Communication (Welsh) was disabled successfully.":
    "Roedd cyfathrebu (Cymraeg) yn anabl yn llwyddiannus.",
  "Digital Literacy was enabled successfully.":
    "Hwyluswyd Llythrennedd Digidol yn llwyddiannus.",
  "Digital Literacy was disabled successfully.":
    "Roedd Llythrennedd Digidol yn anabl yn llwyddiannus.",
  "Digital Literacy Self-Assessment was enabled successfully.":
    "Mae Hunanasesiad Llythrennedd Digidol wedi'i alluogi'n llwyddiannus.",
  "Digital Literacy Self-Assessment was disabled successfully.":
    "Mae Hunanasesiad Llythrennedd Digidol wedi'i analluogi'n llwyddiannus.",
  "Application of Number was assigned successfully.":
    "Neilltuwyd cymhwyso Rhif yn llwyddiannus.",
  "Application of Number was unassigned successfully.":
    "Ni chafodd Cymhwyso Rhif ei aseinio'n llwyddiannus.",
  "Communication (English) was assigned successfully.":
    "Cyfathrebu (Saesneg) wedi'i aseinio'n llwyddiannus.",
  "Communication (English) was unassigned successfully.":
    "Ni chafodd Cyfathrebu (Saesneg) ei aseinio'n llwyddiannus.",
  "Communication (Welsh) was assigned successfully.":
    "Neilltuwyd Cyfathrebu (Cymraeg) yn llwyddiannus.",
  "Communication (Welsh) was unassigned successfully.":
    "Ni chafodd Cyfathrebu (Cymraeg) ei aseinio'n llwyddiannus.",
  "Digital Literacy was assigned successfully.":
    "Neilltuwyd Llythrennedd Digidol yn llwyddiannus.",
  "Digital Literacy was unassigned successfully.":
    "Ni chafodd Llythrennedd Digidol ei aseinio'n llwyddiannus.",
  "Digital Literacy Self-Assessment was assigned successfully.":
    "Cafodd Hunanasesiad Llythrennedd Digidol ei aseinio'n llwyddiannus.",
  "Digital Literacy Self-Assessment was unassigned successfully.":
    "Cafodd Hunanasesiad Llythrennedd Digidol ei ddadaseinio'n llwyddiannus.",
  "Entry 1": "Mynediad 1",
  "Entry 2": "Mynediad 2",
  "Entry 3": "Mynediad 3",
  "Level 1": "Lefel 1",
  "Level 2": "Lefel 2",
  "Level 3": "Lefel 3",
  "Pre-entry": "Cyn-mynediad",
  "Up to 15 mins": "Hyd at 15 munud",
  "15-30 mins": "15-30 munud",
  "30-60 mins": "30-60 munud",
  "Over 1 hour": "Dros awr",
  "item selected": "eitem ddethol",
  "items selected": "eitemau dethol",
  item: "eitem",
  items: "eitemau",
  "I need to keep working on this": "Mae angen i mi weithio ar hyn",
  "I am making good progress with this": "Dw i'n gwneud cynnydd da gyda hyn",
  "I may need help with this": "Efallai byddai angen help gyda hyn",
  "I need to keep working on this skill at this level":
    "Mae angen i mi weithio ar y sgil yma ar y lefel yma",
  "I am making good progress with this skill at this level":
    "Dw i'n gwneud cynnydd da gyda'r sgil yma ar y lefel yma",
  "I may need help with this skill at this level":
    "Efallai byddai angen help gyda'r sgil yma ar y lefel yma",
  "All levels": "Pob lefel",
  "The email entry fields do not match. Please enter the same email in both fields and try again":
    "Nid yw'r meysydd mynediad e-bost yn cyfateb. Rhowch yr un e-bost yn y ddau faes a cheisiwch eto.",
  "The password entry fields do not match. Please enter the same password in both fields and try again":
    "Nid yw'r meysydd mynediad cyfrinair yn cyfateb. Rhowch yr un cyfrinair yn y ddau faes a rhowch gynnig arall arni.",
  "User is not associated with Learner":
    "Nid yw'r defnyddiwr yn gysylltiedig â Dysgwr",
  "Current email and New email should not be the same.":
    "Ni ddylai e-bost presennol ac e-bost newydd fod yr un peth.",
  "Email already exists.": "Cyfeiriad e-bost eisoes yn bodoli.",
  "No access to course. Redirecting to list.":
    "Dim mynediad i gwrs. Ailgyfeirio i'r rhestr.",
  "Resources added successfully.": "Ychwanegwyd adnoddau yn llwyddiannus.",
  "Resources removed successfully.": "Gwaredodd adnoddau yn llwyddiannus.",
  "Resources updated successfully.":
    "Adnoddau wedi'u diweddaru'n llwyddiannus.",
  CURRENT: "BRESENNOL",
  PREVIOUS: "BLAENOROL",
  "Application of Number - Not used": "Cymhwyso Rhif - Heb ei ddefnyddio",
  "Communication (English) - Not used":
    "Cyfathrebu (Saesneg) - Heb ei ddefnyddio",
  "Communication (Welsh) - Not used":
    "Cyfathrebu (Cymraeg) - Heb ei ddefnyddio",
  "Digital Literacy (beta) - Not used":
    "Llythrennedd Digidol (beta) - Heb ei ddefnyddio",
  "ESOL - Not used": "ESOL - Heb ei ddefnyddio",
  "This facility is for tutors and administrators who have learners who completed an initial assessment outside WEST":
    "Mae'r cyfleuster hwn ar gyfer tiwtoriaid a gweinyddwyr sydd â dysgwyr a gwblhaodd asesiad cychwynnol y tu allan i WEST",
  "Sign in": "Mewngofnodwch",
  "Account created:": "Cyfrif wedi'i greu:",
  "Account enabled:": "Cyfrif wedi'i alluogi:",
  "Account disabled:": "Cyfrif wedi'i analluogi:",
  "Move centre:": "Canolfan symud:",
  "External initial assessment result entered for":
    "Canlyniad asesiad cychwynnol allanol y cofrestrwyd amdano",
  "Admin requested learner details:":
    "Gofynnodd y gweinyddwr am fanylion y dysgwr:",
  "Copy of learning requested:": "Gofynnwyd am gopi o ddysgu:",
  "Learning copied:": "Dysgu wedi'i gopïo:",
  "Request to copy learning rejected": "Cais i gopïo dysgu wedi'i wrthod",
  "Request to copy learning withdrawn": "Cais i gopïo dysgu wedi'i dynnu'n ôl",
  "Added to group(s):": "Wedi'i ychwanegu at grŵp(iau):",
  "Removed from group(s):": "Wedi'i dynnu o'r grŵp(iau):",
  Learners: "Dysgwyr",
  "Learner Activity": "Gweithgaredd Dysgwyr",
  "Overall initial assessment result":
    "Canlyniad asesiad cychwynnol cyffredinol",
  "Application of Number initial assessment breakdown":
    "Dadansoddiad asesiad cychwynnol Cymhwyso Rhif",
  "Communication (English) initial assessment breakdown":
    "Cyfathrebu (Saesneg) dadansoddiad cychwynnol o'r asesiad",
  "Communication (Welsh) initial assessment breakdown":
    "Dadansoddiad o asesiad cychwynnol Cyfathrebu (Cymraeg).",
  "Digital Literacy initial assessment breakdown":
    "Dadansoddiad cychwynnol Llythrennedd Digidol",
  "ESOL initial assessment breakdown": "Dadansoddiad asesiad cychwynnol ESOL",
  "Application of Number distance travelled (by skill)":
    "Cymhwyso Rhif y pellter a deithiwyd (yn ôl sgil)",
  "Communication (English) distance travelled (by skill)":
    "Cyfathrebu (Saesneg) pellter a deithiwyd (yn ôl sgil)",
  "Communication (Welsh) distance travelled (by skill)":
    "Cyfathrebu (Cymraeg) pellter a deithiwyd (yn ôl sgil)",
  "Digital Literacy distance travelled (by skill)":
    "Pellter Llythrennedd Digidol a deithiwyd (yn ôl sgil)",
  "Digital Literacy Self-Assessment distance travelled (by skill)":
    "Pellter Hunan-asesu Llythrennedd Digidol a deithiwyd (yn ôl sgil)",    
  "ESOL distance travelled (by skill);":
    "ESOL pellter a deithiwyd (yn ôl sgil);",
  "Application of Number distance travelled":
    "Cymhwyso Rhif pellter a deithiwyd",
  "Communication (English) distance travelled":
    "Cyfathrebu (Saesneg) pellter a deithiwyd",
  "Communication (Welsh) distance travelled":
    "Cyfathrebu (Cymraeg) pellter a deithiwyd",
  "Digital Literacy distance travelled":
    "Pellter Llythrennedd Digidol a deithiwyd",
  "Digital Literacy Self-Assessment distance travelled":
    "Pellter Hunan-asesiad Llythrennedd Digidol a deithiwyd",
  "ESOL distance travelled": "ESOL pellter a deithiwyd",
  Enabled: "Galluogwyd",
  Disabled: "Anabl",
  "Not started": "Heb ddechrau",
  "In progress": "Ar y gweill",
  WEST: "GORLLEWIN",
  External: "Allanol",
  "Overview of learner account status and activity dates. (Note, 'Last activity date' is updated not just by learner activity but also when assessment results are entered manually or uploaded from the offline tool.)":
    "Trosolwg o statws cyfrif dysgwr a dyddiadau gweithgaredd. (Sylwer, mae 'dyddiad gweithgaredd olaf' yn cael ei ddiweddaru nid yn unig yn ôl gweithgaredd dysgwyr ond hefyd pan fydd canlyniadau asesiadau'n cael eu mewnbynnu â llaw neu'n cael eu llwytho i fyny o'r offeryn all-lein.)",
  "Overview of learner course assignments. (Note, 'Last activity date' is updated not just by learner activity but also when assessment results are entered manually or uploaded from the offline tool.)":
    "Trosolwg o aseiniadau cwrs dysgwyr. (Sylwer, mae 'dyddiad gweithgaredd olaf' yn cael ei ddiweddaru nid yn unig yn ôl gweithgaredd dysgwyr ond hefyd pan fydd canlyniadau asesiadau'n cael eu mewnbynnu â llaw neu'n cael eu llwytho i fyny o'r offeryn all-lein.)",
  "User not found": "Defnyddiwr heb ei ganfod",
  "Free writing activity 1": "Dynodi 'Gweithgaredd ysgrifennu rhydd 1'",
  "Free writing activity 2": "Dynodi 'Gweithgaredd ysgrifennu rhydd 2'",
  "Check your skills (free writing activity with context)":
    "Dynodi 'Gwiriwch eich sgiliau (gweithgaredd ysgrifennu rhydd â chyd-destun)'",
  "My organisation": "Fy sefydliad",
  "Another organisation": "Sefydliad arall",
  "Any organisation": "Unrhyw sefydliad",
  "Summary of completed initial assessments:":
    "Crynodeb o'r asesiadau cychwynnol a gwblhawyd:",
  "Details of initial assessment results in Application of Number:":
    "Manylion canlyniadau asesiad cychwynnol Cymhwyso Rhif:",
  "Details of initial assessment results in Communication (English):":
    "Manylion canlyniadau asesiad cychwynnol Cyfathrebu (Saesneg):",
  "Details of initial assessment results in Communication (Welsh):":
    "Manylion canlyniadau asesiad cychwynnol Cyfathrebu (Cymraeg):",
  "Details of initial assessment results in Digital Literacy:":
    "Manylion canlyniadau asesiad cychwynnol Llythrennedd Digidol:",
  "Distance travelled by each learner in specified skill, as measured by skills checks:":
    "Y pellter a deithiwyd gan bob dysgwr mewn sgil penodol, fel y’i mesurir gan wiriadau sgiliau",
  "Distance travelled by each learner in specified skill, as measured by skills checks:<br/>Note that tutor-marked skills checks are not included.":
    "Y pellter a deithiwyd gan bob dysgwr mewn sgil penodol, fel y'i mesurwyd gan wiriadau sgiliau:<br/>Sylwer nad yw gwiriadau sgiliau wedi'u marcio gan diwtor wedi'u cynnwys.",
  "skill/s selected": "sgil/sgiliau a ddewiswyd",
  "course/s selected": "cwrs/cyrsiau a ddewiswyd",
  "FIRST NAME": "ENW CYNTAF",
  "LAST NAME": "ENW OLAF",
  "USERNAME": "ENW DEFNYDDIWR",
  "EMAIL": "E-BOST",
  "COURSE NAME": "ENW'R CWRS",
  "SKILL": "SGIL",
  "IA RESULT IN SKILL": "IA CANLYNIAD MEWN SGIL",
  "ENTRY 1": "MYNEDIAD 1",
  "ENTRY 2": "MYNEDIAD 2",
  "ENTRY 3": "MYNEDIAD 3",
  "LEVEL 1": "LEFEL 1",
  "LEVEL 2": "LEFEL 2",
  "LEVEL 3": "LEFEL 3",
  "SUMMARY": "CRYNODEB",
  "GROUP": "GRWP",
  "ORGANISATION": "SEFYDLIAD",
  "CENTRE": "CANOLFAN",
  "DATE CREATED": "DYDDIAD CREU",
  "ACCOUNT STATUS": "STATWS CYFRIF",
  "COURSES": "CYRSIAU",
  "LAST LOGIN DATE": "DYDDIAD LLOFNODI DIWETHAF",
  "LAST ACTIVITY DATE": "DYDDIAD GWEITHGAREDD OLAF",
  "COURSE STATUS": "STATWS CWRS",
  "CURRENTLY AT": "AR HYN O BRYD AT",
  "INITIAL ASSESSMENT": "ASESIAD CYCHWYNNOL",
  "COURSE": "CWRS",
  "OVERALL RESULT": "CANLYNIAD CYFFREDINOL",
  "DATE COMPLETED": "DYDDIAD CWBLHAU",
  "TOTAL TIME TAKEN": "CYFANSWM AMSER A GYMERWYD",
  "COMPLETED AT THIS ORGANISATION": "CWBLHAWYD YN Y SEFYDLIAD HWN",
  "USING DATA": "DEFNYDDIO DATA",
  "WHOLE NUMBERS": "RHIFAU CYFAN",
  "FRACTIONS, DECIMALS AND PERCENTAGES": "FFRACSIYNAU, DEGOLION A CHANRANNAU",
  "MEASURES, MONEY AND TIME": "MESURAU, ARIAN AC AMSER",
  "SHAPE, SPACE AND POSITION": "SIÂP, GOFOD A LLEOLIAD",
  "PROPORTION, RATIO AND SCALE": "CYFRANNEDD, CYMHAREB A GRADDFA",
  "FORMULAS AND EQUATIONS": "FFORMIWLÂU A HAFALIADAU",
  "STATISTICS AND PROBABILITY": "YSTADEGAU A THEBYGOLRWYDD",
  "SPEAKING AND LISTENING": "SIARAD A GWRANDO",
  "READING": "DARLLEN",
  "READ AND UNDERSTAND WORDS": "DARLLEN A DEALL GEIRIAU",
  "READ AND UNDERSTAND TEXT": "DARLLEN A DEALL TESTUN",
  "READ TEXT TO FIND INFORMATION": "DARLLEN TESTUN I DDOD O HYD I WYBODAETH",
  "WRITING": "YSGRIFENNU",
  "WRITE RELEVANT AND APPROPRIATE TEXT": "YSGRIFENNU TESTUN PERTHNASOL A PHRIODOL",
  "SPELL CORRECTLY": "SILLAFU’N GYWIR",
  "PUNCTUATE CORRECTLY": "ATALNODI’N GYWIR",
  "USE CORRECT GRAMMAR": "DEFNYDDIO GRAMADEG YN GYWIR",
  "DIGITAL LITERACY": "LLYTHRENNEDD DIGIDOL",
  "DIGITAL LITERACY SELF-ASSESSMENT": "LLYTHRENNEDD DIGIDOL HUNAN-ASESIAD",
  "DIGITAL RESPONSIBILITY": "CYFRIFOLDEB DIGIDOL",
  "DIGITAL PRODUCTIVITY": "CYNHYRCHIANT DIGIDOL",
  "DIGITAL INFORMATION LITERACY": "LLYTHRENNEDD GWYBODAETH DDIGIDOL",
  "DIGITAL COLLABORATION": "CYDWEITHIO DIGIDOL",
  "DIGITAL CREATIVITY": "CREADIGRWYDD DIGIDOL",
  "DIGITAL LEARNING": "DYSGU DIGIDOL",
  "Learner statistics (all courses)" : "Ystadegau dysgwr (pob cwrs)",
  "Learner statistics (single course)": "Ystadegau dysgwr (cwrs unigol)",
  "Screener statistics (all courses)": "Ystadegau profion sgrinio (pob cwrs)",
  "Screener statistics (single course)": "Ystadegau profion sgrinio (cwrs unigol)",
  "Initial assessment statistics (all courses)": "Ystadegau asesiadau cychwynnol (pob cwrs)",
  "Initial assessment statistics (single course)": "Ystadegau asesiadau cychwynnol (cwrs unigol)",
  "This report shows the following:<ul><li><strong>Registered</strong> learners - total (and as a percentage of all learners in WEST)</li><li>Registered learners who have <strong>No assigned courses</strong> - total (and as a percentages of all learners in this organisation)</li><li>Learners who have <strong>Not started</strong> at least one course - total (and as a percentage of all learners in this organisation)</li><li>Learners currently doing an <strong>Initial assessment</strong> in at least one course - total (and as a percentage of all learners in this organisation)</li><li>Learners at the <strong>Learning</strong> stage in at least one course - total (and as a percentage of all learners in this organisation)</li></ul>Note: figures in the report below are for all courses,  so an individual learner may be counted in more than one column." : 
    "Mae'r adroddiad hwn yn dangos y canlynol:<ul><li>Dysgwyr <strong>Wedi cofrestru</strong>  - cyfanswm (ac fel canran o'r holl ddysgwyr yn WEST)</li><li>Dysgwyr wedi cofrestru sydd <strong>Heb gyrsiau wedi eu dynodi</strong> - cyfanswm (ac fel canran o'r holl ddysgwyr yn y sefydliad hwn)</li><li>Dysgwyr <strong>Heb ddechrau</strong>  o leiaf un cwrs - cyfanswm (ac fel canran o'r holl ddysgwyr yn y sefydliad hwn)</li><li>Dysgwyr sy'n gwneud <strong>Asesiad cychwynnol</strong> ar hyn o bryd mewn un cwrs o leiaf - cyfanswm (ac fel canran o'r holl ddysgwyr yn y sefydliad hwn)</li><li>Dysgwyr ar y cam <strong>Dysgu</strong> mewn o leiaf un cwrs - cyfanswm (ac fel canran o'r holl ddysgwyr yn y sefydliad hwn)</li></ul>Sylwer: mae'r niferoedd yn yr adroddiad isod ar gyfer yr holl gyrsiau, felly gall dysgwr unigol gael ei gyfrif mewn mwy nag un golofn.",
  "This report shows the following:<ul><li><strong>Registered</strong> learners - total (and as a percentage of all learners in WEST)</li><li>Learners who have <strong>Not started</strong> - total (and as a percentage of all learners in this organisation)</li><li>Learners currently doing an <strong>Initial assessment</strong> - total (and as a percentage of all learners in this organisation)</li><li>Learners who have started <strong>Learning</strong> - total (and as a percentage of all learners in this organisation)</li></ul>": 
    "Mae'r adroddiad hwn yn dangos y canlynol:<ul><li>Dysgwyr <strong>Wedi cofrestru</strong> - cyfanswm (ac fel canran o'r holl ddysgwyr yn WEST)</li><li>Dysgwyr <strong>Heb ddechrau</strong> - cyfanswm (ac fel canran o'r holl ddysgwyr yn y sefydliad hwn)</li><li>Dysgwyr sy'n gwneud <strong>Asesiad cychwynnol</strong> ar hyn o bryd - cyfanswm (ac fel canran o'r holl ddysgwyr yn y sefydliad hwn)</li><li>Dysgwyr yn y cyfnod <strong>Dysgu</strong> - cyfanswm (ac fel canran o'r holl ddysgwyr yn y sefydliad hwn)</li></ul>",
  "<p>This report shows the total number of screener results at each level across all courses.</p>Note: figures in the report below are for all screeners, so an individual learner may be counted in more than one column." : 
    "<p>Mae'r adroddiad hwn yn dangos cyfanswm canlyniadau'r profion sgrinio ar bob lefel ar draws pob cwrs.</p>Sylwer: mae'r niferoedd yn yr adroddiad isod ar gyfer yr holl brofion sgrinio, felly gall dysgwr unigol gael ei gyfrif mewn mwy nag un golofn.",
  "This report shows the total number of screener results at each level:" : "Mae'r adroddiad hwn yn dangos cyfanswm canlyniadau'r profion sgrinio ar bob lefel yn y cwrs:",
  "<p>This report shows the total number of initial assessment results at each level across all courses.</p>Note: figures in the report below are for all initial assessments, so an individual learner may be counted in more than one column." : 
    "<p>Mae'r adroddiad hwn yn dangos cyfanswm canlyniadau'r asesiadau cychwynnol ar bob lefel ar draws pob cwrs.</p>Sylwer: mae'r niferoedd yn yr adroddiad isod ar gyfer yr holl asesiadau cychwynnol, felly gall dysgwr unigol gael ei gyfrif mewn mwy nag un golofn.",
  "This report shows the total number of initial assessment results at each level:" : 
    "Mae'r adroddiad hwn yn dangos cyfanswm canlyniadau'r asesiadau cychwynnol ar bob lefel ar gyfer y cwrs:",
  "No Level Achieved": "Dim Lefel wedi’i Chyrraedd",
  "Not Assessed": "Heb ei Asesu",
  "Yes": "Ie",
  "No": "Na"
};